import React from 'react';
import { IconContext } from '@phosphor-icons/react';
import { Toggle } from 'app/components';
import './style';

const Question = (props) => {
  const {
    disabled,
    label,
    type,
    required,
    showRequiredToggle,
    isRequired,
    onToggle,
    icon,
    ctaList,
    onCtaClick,
    className,
    id,
    isPreset,
    leftIcon,
    leftIconProps,
    requiredToggleProps,
    ...attr
  } = props;

  return (
    <div className={`question-container shadow-xs flex items-center justify-between px-6 py-5`
      + `${disabled ? ' disabled' : ''} ${className}`}
    {...attr}
    >
      <div className="flex items-center justify-center gap-4">
        {leftIcon && (
          <div className="left-icon flex items-center justify-center p-2.5 bg-grey-5 rounded-xl">
            <IconContext.Provider
              value={{
                size: 24,
                color: '#878787',
                weight: 'fill',
                ...leftIconProps,
              }}
            >
              {leftIcon}
            </IconContext.Provider>
          </div>
        )}
        <div className="flex flex-col gap-1">
          <div className="heading-16 text-black">{label}</div>
          <div className="text-14 text-grey-70 capitalize">{type}</div>
        </div>
      </div>
      <div className="flex gap-9 items-center">
        {(showRequiredToggle && !isPreset) && (
          <Toggle
            label="Mandatory"
            checked={isRequired}
            id={id}
            onChange={onToggle}
            {...requiredToggleProps}
          />
        )}
        {(icon && !isPreset) && (
          <div className="toggle-icon">{icon}</div>
        )}
        {(!!ctaList?.length && !isPreset) && (
          <div className="cta-list flex gap-3">
            {ctaList.map((cta) => (
              <div
                className="cta-icon cursor-pointer"
                onClick={() => onCtaClick(cta?.id, label)}
              >
                {cta?.icon}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Question;
